module.exports = __webpack_public_path__ + "static/media/nima-head.bd8c047d.png";